import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[directiveZipCode]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: DirectiveZipCodeDirective,
      multi: true,
    },
  ],
})
export class DirectiveZipCodeDirective implements Validator {
  private zipCodePattern = new RegExp(environment.commonSetting.zipRegex);

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value && !this.zipCodePattern.test(value)) {
      return { invalidZipCode: true };
    }
    return null;
  }
}
